import { IconButton, Tooltip } from "@mui/material";
import { IconTrash } from "@tabler/icons-react";

interface BotonEliminarProductoProps {
  onEliminar: () => void;
  deshabilitado?: boolean;
  nombreProducto?: string;
}

export const BotonEliminarProducto = ({
  onEliminar,
  deshabilitado = false,
  nombreProducto,
}: BotonEliminarProductoProps): JSX.Element => (
  <IconButton
    size="small"
    disabled={deshabilitado}
    onClick={onEliminar}
    aria-label={nombreProducto ? `Quitar ${nombreProducto}` : "Quitar producto"}
    sx={{ color: "#64748b", "&:hover": { color: "#d32f2f", backgroundColor: "transparent" } }}
  >
    <IconTrash stroke={2} size={20} />
  </IconButton>
);
